import { Button } from '@factorialco/deprecated-design-system'
import { SetRegularAccessStartDateDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  employeeId: number
  onClose: () => void
}

const RegularAccessModal = ({ employeeId, onClose }: Props) => {
  const [setRegularAccessStartDate, { loading }] = useMutation(SetRegularAccessStartDateDocument, {
    extractorFn: (data) => data.employeesMutations.setRegularAccessStartDateEmployeesEmployee,
    onCompleted: (data) => {
      if (data.employeesMutations.setRegularAccessStartDateEmployeesEmployee.errors.length === 0) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('employees.regular_access.modal_success'),
        })
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('employees.regular_access.modal_error'),
        })
      }

      onClose()
    },
  })

  return (
    <Modal
      title={i18n.t('employees.regular_access.modal_title')}
      description={i18n.t('employees.regular_access.modal_description')}
      illustration="window-user"
      onSubmit={() =>
        setRegularAccessStartDate({
          variables: { id: employeeId, startsOn: i18nDateToString(moment(), 'backend') },
        })
      }
      onClose={onClose}
      footer={
        <>
          <Button disabled={loading} onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={loading} submit>
            {i18n.t('employees.regular_access.action')}
          </Button>
        </>
      }
    />
  )
}

export default observer(RegularAccessModal)
